import bn from 'bignumber.js';

export default ({ fetch, config, timer, serviceFactory, cache }) => cache((pair) => {
  const profile = config.priceService.profiles[pair.name];
  const interval = config.priceService.interval || 60000;
  if (!profile) {
    throw new Error("Unmapped pair: " + pair.name);
  } else {
    var last = 0;
    var ts = 0;

    return serviceFactory({
      name: 'prices-service - ' + pair.name,
      subscribe: (update) => {

        const sendUpdate = (refreshing = false) => {
          update({
            price: last && bn(last),
            bucket: profile.bucket
          }, refreshing)
        }

        var now = Date.now();
        if (now - ts < interval) sendUpdate();
        last = -1;
        timer.periodic('price-service', interval, () => {
          return fetch(profile.url)
            .then(result => result.ok ? result.json() : Promise.reject(result))
            .then(json => {
              if (json.price !== last) {
                last = json.price;
                ts = Date.now();
                sendUpdate();
              }
            })
        })
        sendUpdate(true);
      }
    })
  }
})


// WEBPACK FOOTER //
// ./src/api/prices-service.js